import React from 'react';
import InputMask from 'react-input-mask';

import {
  FormGroup,
  Col,
  Label,
  Input,
} from 'reactstrap';

const renderInputCheckbox = ({
  name,
  input,
  label,
  text,
  placeholder,
  meta: { touched, error, warning },
}) => (
  <FormGroup row>
   
    <Col md="12">
      <Input {...input} placeholder={placeholder} type={"checkbox"}  className={(touched && error && "error") ? "error" : ""}/>
      {text}
    </Col>
  </FormGroup>
);

export default renderInputCheckbox;
